import api from '@bmp-vue/core/api'

export default {
    FormatCNH(value) {
        if (!value)
            return ''

        value = value.toString().toUpperCase()
        const regex = /([0-9A-Z]{1})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{1})/
        const subst = '$1 $2 $3 $4 $5'
        return value.replace(regex, subst)
    },
    FormatRNE(value) {
        if (!value)
            return ''

        value = value.toString().toUpperCase()
        const regex = /([A-Z]{1})([0-9]{6})([0-9A-Z]{1})/
        const subst = '$1$2-$3'
        return value.replace(regex, subst)
    }
}